import html2pdf from "html2pdf.js";

class DownloadPdfButton {
  constructor(element) {
    this.button = element;
    this.downloadAsPdf();
  }

  downloadAsPdf() {
    this.button.addEventListener("click", () => {

      const elementHTML = document.querySelector("main");
      const options = {
        margin:       1,
        filename:     'siblu-reservation.pdf',
        backgroundColor: null,
        html2canvas:  { scale: 2 },
        jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
      };

      html2pdf().set(options).from(elementHTML).save();
    });
  }
}

const downloadButtons = document.querySelectorAll('[data-download-as-pdf]');

downloadButtons.forEach(  (button) => {
  button.DownloadPdfButton = new DownloadPdfButton(button);
})
